import "./instrument";
import "./windowConfig.d.ts";
import "./i18n.ts";

import { RouterProvider } from "react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import AppContextProvider from "context/appContext";
import router from "router";
import ToastContextProvider from "context/toastContext";
import FileContextProvider from "context/fileUploadContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ThemeContextProvider from "context/themeContext.tsx";
import initializeGA from "googleAnalytics.ts";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

initializeGA();

root.render(
  <React.StrictMode>
    <ThemeContextProvider>
      <FileContextProvider>
        <AppContextProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ToastContextProvider>
              <RouterProvider router={router} />
            </ToastContextProvider>
          </LocalizationProvider>
        </AppContextProvider>
      </FileContextProvider>
    </ThemeContextProvider>
  </React.StrictMode>,
);
